<template>
<div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-9">
<h3 class="text-primary mb-3 mt-3 font-medium">{{title}}</h3>
</div>

<div class="col-2 md:col-3">
<template v-if="show_button">
<div class="flex align-items-center justify-content-end">
<div class="hide_on_mobile "><Button type="button" :class="'p-button-'+buttontype+' p-button-outlined p-button-sm mt-2'" :label="label" :icon="'pi pi-'+icon" @click="goToUrl" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-'+buttontype+' p-button-outlined p-button-sm mt-2'" :icon="'pi pi-'+icon" @click="goToUrl" /></div>
</div>
</template>
</div>
</div>	
</template>

<script>
export default {

  name: 'ContentHeader',
  props:["title","label","url","show_button","icon","buttontype","urlparams"],
  data () {
    return {
    	items:[
    	{
		label: 'Profil',
			icon: 'pi pi-user',
			class:"test"
		},
		{
			label: 'Bildirimler',
			icon: 'pi pi-bell'
		},
		]
    }
  },
  methods:{
  	toggle(event) {
        this.$refs.menu.toggle(event);
    },
    goToUrl()
    {
      
      if(this.urlparams)
      {
        this.$router.push({ name:  this.url, params: this.urlparams })  
      }
      else
      {
        this.$router.push({ name: this.url})
      }
    	
    }
  }
};
</script>

<style lang="css" scoped>
</style>